import React, { FC, useMemo } from 'react';

import { useComponentModuleBySeasonQuery } from '../../../redux/ducks/contentModulesBySeason';

type Props = {
    backupContent?: any;
    className?: string;
    defaultHeroImage?: string;
    seasonId: number;
    sequence: number;
    templateKey?: string;
};

const DEFAULT_HERO_IMAGE =
    'https://records.nhl.com/site/asset/public/images/2020/04/stanley-cup-bowl-1440x480-03122700.jpg';

const createContentModule =
    (className = '') =>
    (children) =>
        <div className={`content-module-container ${className}`}>{children}</div>;

const ContentModulesBySeason: FC<Props> = ({
    backupContent = '',
    className = '',
    defaultHeroImage = DEFAULT_HERO_IMAGE,
    seasonId,
    sequence,
    templateKey,
}) => {
    const contentArgs = useMemo(() => ({ seasonId, templateKey }), [seasonId, templateKey]);
    const { data: contentModules = [], isSuccess } = useComponentModuleBySeasonQuery(contentArgs);
    const content = contentModules.length > 0 && contentModules.find((module) => module.sequence === sequence)?.content;
    const moduleClassName = sequence === 1 ? 'module' : '';

    if (!isSuccess) {
        return createContentModule(className)(<div className={moduleClassName} />);
    } else if (content) {
        return createContentModule(className)(
            <div className={moduleClassName} dangerouslySetInnerHTML={{ __html: content }} />
        );
    } else if (backupContent) {
        return createContentModule(className)(<div className={moduleClassName}>{backupContent}</div>);
    }
    return createContentModule(className)(
        <div className={moduleClassName}>
            <img src={defaultHeroImage} />
        </div>
    );
};

export default ContentModulesBySeason;
